import { render, staticRenderFns } from "./CommonFormWithAreaCodeEditor.vue?vue&type=template&id=4abf0480&lang=pug&"
import script from "./CommonFormWithAreaCodeEditor.vue?vue&type=script&lang=ts&"
export * from "./CommonFormWithAreaCodeEditor.vue?vue&type=script&lang=ts&"
import style0 from "./CommonFormWithAreaCodeEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports